import React from "react";
import {Box, Typography, List, ListItem, Button, TextField, IconButton} from "@mui/material";
import dayjs from "dayjs";
import {addMessageToTop, Comment} from "@store/chatSlice.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import SendIcon from "@assets/icons/sendIcon.tsx";

const DisplayMetraIds = () => {
    const dispatch = useDispatch<AppDispatch>();
    const {user} = useSelector((state: any) => state.user);
    const {metraData} = useSelector((state: any) => state.chat);
    const [disabled, setDisabled] = React.useState(false);
    const [metraId, setMetraId] = React.useState('');
    const selectOption = (e: any) => {
        const comment: Comment = {
            id: 3,
            createdAt: dayjs().format(),
            attachments: [],
            type: 'comment',
            userName: null,
            body: e.target.innerText,
            public: true,
            autherId: user.zendeskUserId
        }
        dispatch(addMessageToTop(comment));
        setDisabled(true);
        setTimeout(() => {
            const comment: Comment = {
                id: 4,
                createdAt: dayjs().format(),
                attachments: [],
                type: 'comment',
                userName: null,
                body: 'Describe your issue.',
                public: true,
                autherId: 1
            }
            dispatch(addMessageToTop(comment));
        })
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                marginTop: "2rem",
            }}
        >
            <Box
                sx={{
                    alignItems: "flex-end",
                    display: "flex",
                    flexDirection: "column",
                    width: "auto",
                    maxWidth: "70%",
                }}
            >
                <Box className="flex">
                    <Box
                        sx={{
                            borderRadius: "50%",
                            bgcolor: "#fff",
                            width: "35px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mr: 1,
                        }}
                    >
                        <Typography sx={{fontSize: "0.8rem"}}>
                            OX
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: "white",
                            p: 2,
                            borderRadius: 1,
                            border: "1px solid #ddd",
                        }}
                    >
                        <Box sx={{display: "flex", alignItems: "center", mb: 1}}>
                            <Typography
                                variant="body1"
                                sx={{fontWeight: "normal", whiteSpace: "pre-line", color:"#000000BF"}}
                            >
                                Please select the Metra ID
                            </Typography>
                        </Box>
                        <List disablePadding>
                            {metraData?.data.map((metra) => (
                                <ListItem key={metra.metraId} disableGutters sx={{p: 0.5}}>
                                    <Button
                                        disabled={disabled}
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            justifyContent: "flex-start",
                                            textAlign: "left",
                                            bgcolor: "#E2F1F9",
                                            color: "#262626",
                                            "&:hover": {
                                                bgcolor: "#E2F1F9",
                                            },
                                        }}
                                        onClick={selectOption}
                                    >
                                        {metra.metraName ? metra.metraName : metra.metraId}
                                    </Button>
                                </ListItem>
                            ))}
                            <span className={'flex gap-2 items-center mt-2 ms-1'}>
                                <TextField
                                    variant="outlined"
                                    placeholder={'Enter Metra ID'}
                                    fullWidth
                                    size={"small"}
                                    disabled={disabled}
                                    value={metraId}
                                    onKeyUp={(e) => {
                                        if (e.code === 'Enter') {
                                            selectOption(
                                                {target: {innerText: metraId}})
                                        }
                                    }}
                                    onChange={(e) => setMetraId(e.target.value)}
                                />
                                <IconButton onClick={() => {
                                    selectOption(
                                        {target: {innerText: metraId}})
                                }} disabled={disabled}>
                                 <SendIcon/>
                                </IconButton>
                            </span>

                        </List>
                    </Box>
                </Box>
                <Box>
                    <Typography variant="caption" color="textSecondary">
                        {dayjs().format('DD-MMM HH:mm')}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};
export default DisplayMetraIds;
